import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Correction from './correction';
import CorrectionDetail from './correction-detail';
import CorrectionUpdate from './correction-update';
import CorrectionDeleteDialog from './correction-delete-dialog';

const CorrectionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Correction />} />
    <Route path="new" element={<CorrectionUpdate />} />
    <Route path=":id">
      <Route index element={<CorrectionDetail />} />
      <Route path="edit" element={<CorrectionUpdate />} />
      <Route path="delete" element={<CorrectionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CorrectionRoutes;
